import React from 'react';
import AdminGroupListContainer from '@src/components/administration/AdminGroupListContainer';
import { UserGroupTypeEnum } from '@src/model/usergroup/UserGroup';

const AdminOrganizationGroupListPage = () => <AdminGroupListContainer groupType={UserGroupTypeEnum.ORGANIZATION} />;

export default AdminOrganizationGroupListPage as any;
